/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Error from '../model/Error';

/**
* Dealer service.
* @module api/DealerApi
* @version 0.0.1
*/
export default class DealerApi {

    /**
    * Constructs a new DealerApi. 
    * @alias module:api/DealerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createDealer operation.
     * @callback module:api/DealerApi~createDealerCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} dealerName The dealer name to add
     * @param {module:api/DealerApi~createDealerCallback} callback The callback function, accepting three arguments: error, data, response
     */
    createDealer(dealerName, callback) {
      let postBody = null;
      // verify the required parameter 'dealerName' is set
      if (dealerName === undefined || dealerName === null) {
        throw new Error("Missing the required parameter 'dealerName' when calling createDealer");
      }

      let pathParams = {
      };
      let queryParams = {
        'dealerName': dealerName
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/dealer', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteDealer operation.
     * @callback module:api/DealerApi~deleteDealerCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} ID ID of the dealer to delete
     * @param {module:api/DealerApi~deleteDealerCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteDealer(ID, callback) {
      let postBody = null;
      // verify the required parameter 'ID' is set
      if (ID === undefined || ID === null) {
        throw new Error("Missing the required parameter 'ID' when calling deleteDealer");
      }

      let pathParams = {
        'ID': ID
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/dealer/{ID}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updateDealer operation.
     * @callback module:api/DealerApi~updateDealerCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} ID The dealer to be updated
     * @param {String} newDealerName The new dealer name
     * @param {module:api/DealerApi~updateDealerCallback} callback The callback function, accepting three arguments: error, data, response
     */
    updateDealer(ID, newDealerName, callback) {
      let postBody = null;
      // verify the required parameter 'ID' is set
      if (ID === undefined || ID === null) {
        throw new Error("Missing the required parameter 'ID' when calling updateDealer");
      }
      // verify the required parameter 'newDealerName' is set
      if (newDealerName === undefined || newDealerName === null) {
        throw new Error("Missing the required parameter 'newDealerName' when calling updateDealer");
      }

      let pathParams = {
        'ID': ID
      };
      let queryParams = {
        'newDealerName': newDealerName
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/dealer/{ID}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
